<template>
    <div class="m-form__section m-form__section--third">
        <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-3 col-sm-12">{{ labels['date_purchase'] }} * :</label>
            <div class="col-lg-4 col-md-9 col-sm-12">
                <div class="input-group date">
                    <input type="text" class="form-control m-input m_datepicker toto" readonly="" :placeholder="labels['select_date']" data-name="datePurchase">
                    <div class="input-group-append">
                        <span class="input-group-text">
                            <i class="la la-calendar-check-o"></i>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group m-form__group row" v-show="stock.availableCIP === 'yes'">
            <label class="col-lg-3 col-form-label">{{ labels['place_storage'] }} :</label>
            <div class="col-lg-6">
                <input type="text" class="form-control m-input" v-model="stock.codeStorage">
            </div>
        </div>
        <div class="form-group m-form__group row">
            <label class="col-lg-3 col-form-label">{{ labels['period_pao'] }} {{ labels['in_months'] }} :</label>
            <div class="col-lg-6">
                <input type="text" class="form-control m-input" v-model="stock.periodPao">
            </div>
        </div>
        <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-3 col-sm-12">{{ labels['date_expiration'] }} :</label>
            <div class="col-lg-4 col-md-9 col-sm-12">
                <div class="input-group date">
                    <input type="text" class="form-control m-input m_datepicker" readonly="" :placeholder="labels['select_date']" data-name="dateExpiration">
                    <div class="input-group-append">
                        <span class="input-group-text">
                            <i class="la la-calendar-check-o"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-sm-2" v-show="stock.dateExpiration">
                <button type="button" class="btn btn-outline-dark btn-elevate m-btn m-btn--icon btn--icon-only m-btn--icon-only m-btn--pill btn-sm" @click="clearDate('dateExpiration')"><i class="la la-close"></i></button>
            </div>
        </div>
        <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-3 col-sm-12">{{ labels['date_opened'] }} :</label>
            <div class="col-lg-4 col-md-9 col-sm-12">
                <div class="input-group date">
                    <input type="text" class="form-control m-input m_datepicker" readonly="" :placeholder="labels['select_date']" data-name="dateOpened">
                    <div class="input-group-append">
                        <span class="input-group-text">
                            <i class="la la-calendar-check-o"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-sm-2" v-show="stock.dateOpened">
                <button type="button" class="btn btn-outline-dark btn-elevate m-btn m-btn--icon btn--icon-only m-btn--icon-only m-btn--pill btn-sm" @click="clearDate('dateOpened')"><i class="la la-close"></i></button>
            </div>
        </div>
        <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-3 col-sm-12">{{ labels['source'] }} * :</label>
            <div class="col-lg-4 col-md-9 col-sm-12">
                <select :class="'form-control stock-choices-'+index" title="Choose one of the following..." v-model="stock.source">
                    <option value="" disabled selected>{{ labels['select_an_option'] }}</option>
                    <option value="Boutique">Boutique</option>
                    <option value="Internet">Internet</option>
                    <option value="Pays">Pays</option>
                </select>
            </div>
        </div>
        <div class="m-form__group form-group row">
            <label class="col-lg-3 col-form-label">{{ labels['product_on_loan'] }} :</label>
            <div class="col-lg-6">
                <div class="m-radio-inline">
                    <label class="m-radio m-radio--solid" for="productOnLoan_yes">
                        <input type="radio" id="productOnLoan_yes" name="productOnLoan_yes" checked="" v-model="stock.isLoaned" :value="true"> {{ labels.yes }}
                        <span></span>
                    </label>
                    <label class="m-radio m-radio--solid" for="productOnLoan_no">
                        <input type="radio" id="productOnLoan_no" name="productOnLoan_no" v-model="stock.isLoaned" :value="false"> {{ labels.no }}
                        <span></span>
                    </label>
                </div>
            </div>
        </div>
        <div v-show="stock.isLoaned">
            <div class="form-group m-form__group row">
                <label class="col-form-label col-lg-3 col-sm-12">{{ labels['date_loaned'] }} :</label>
                <div class="col-lg-4 col-md-9 col-sm-12">
                    <div class="input-group date">
                        <input type="text" class="form-control m-input m_datepicker" readonly="" :placeholder="labels['select_date']" data-name="dateLoaned">
                        <div class="input-group-append">
                        <span class="input-group-text">
                            <i class="la la-calendar-check-o"></i>
                        </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group m-form__group row">
                <label class="col-lg-3 col-form-label">{{ labels['borrower'] }} :</label>
                <div class="col-lg-6">
                    <input type="text" class="form-control m-input" v-model="stock.borrower">
                </div>
            </div>
            <div class="form-group m-form__group row">
                <label class="col-lg-3 col-form-label">{{ labels['email_borrower'] }} :</label>
                <div class="col-lg-6">
                    <input type="email" class="form-control m-input" v-model="stock.emailBorrower">
                </div>
            </div>
        </div>
        <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-3 col-sm-12">{{ labels['package_type'] }} :</label>
            <div class="col-lg-4 col-md-9 col-sm-12">
                <select :class="'form-control stock-choices-'+index" title="Choose one of the following..." v-model="stock.typePackId">
                    <option value="" disabled selected>{{ labels['select_an_option'] }}</option>
                    <option v-for="pack in typePacks" :value="pack.type_pack_id" :selected="pack.type_pack_id === stock.typePackId">{{ pack.name }}</option>
                </select>
            </div>
        </div>
        <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-3 col-sm-12">{{ labels['package_capacity'] }} :</label>
            <div class="col-lg-4 col-md-9 col-sm-12">
                <select :class="'form-control stock-choices-'+index" title="Choose one of the following..." v-model="stock.packageCapacityId">
                    <option value="" disabled selected>{{ labels['select_an_option'] }}</option>
                    <option v-for="pack in packageCapacities" :value="pack.package_capacity_id" :selected="pack.package_capacity_id === stock.packageCapacityId">{{ pack.name }}</option>
                </select>
            </div>
        </div>
        <div class="m-form__actions m-form__actions">
            <div class="row">
                <div class="col-lg-7">{{ labels['required_fields_info'] }}</div>
                <div class="col-lg-1">
                    <button type="button" class="btn btn-secondary" @click="cancelForm">{{ labels.cancel }}</button>
                </div>
                <div class="col-lg-1">
                    <button type="button" class="btn btn-primary" @click="performAction(submitBtns[id].action)">{{ labels[submitBtns[id].label] }}</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { mapState, mapActions } from 'vuex';
import Choices from 'choices.js';
import { HTTP } from '../../assets/js/axiosConfig';
import { eventBus } from '../../main';

import Uuid from '../../assets/js/mixins';
import SweetAlert from '../../assets/js/mixins';
import InitDatePicker from '../../assets/js/mixins';
import SetDefaultDate from '../../assets/js/mixins';
import ToSnakeCase from '../../assets/js/mixins';
import ToCamelCase from '../../assets/js/mixins';

const timer = 3000;

export default {
  name: 'StockForm',
  props: ['productId', 'index', 'id', 'myStock', 'product'],
  mixins: [Uuid, SweetAlert, InitDatePicker, SetDefaultDate, ToSnakeCase, ToCamelCase],
  data() {
    return {
      stock: {
        datePurchase: null, // Timestamp
        dateExpiration: null, // Timestamp
        source: '', // Boutique, Internet, Pays
        periodPao: null,
        dateOpened: null, // Timestamp
        codeStorage: '',
        dateLoaned: null, // Timestamp
        borrower: '',
        emailBorrower: '',
        availableCIP: 'yes', // Oui / en commande / no
        isLoaned: false,
        isOpened: false,
        typePackId: '',
        packageCapacityId: '',
      },
      months: [3, 6, 9, 12, 15, 18, 24, 36],
      timeout: null,
      submitBtns: {
        new: {
          label: 'add_to_stock',
          action: 'addStockEntry',
        },
        edit: {
          label: 'update_stock',
          action: 'updateStock',
        },
        newStock: {
          label: 'add_to_stock',
          action: 'addStockEntry',
        },
      },
      today: new Date().getTime() / 1000,
    };
  },
  computed: {
    ...mapState({
      labels: (store) => store.labels,
      editingStock: (store) => store.stocks.editingStock,
      keywords: (store) => store.stocks.keywords,
      openedIndex: (store) => store.stocks.openedIndex,
      typePacks: (store) => store.crudData.cruds.type_packs,
      packageCapacities: (store) => store.crudData.cruds.package_capacities,
    }),
    stockId() {
      if (this.myStock) {
        return this.myStock.stock_id;
      } if (this.editingStock) {
        return this.editingStock.objectID;
      }
      return this.uuid();
    },
    stockSnakeCase() {
      const stock = {
        date_purchase: this.dateConversion(this.stock.datePurchase),
        date_expiration: this.dateConversion(this.stock.dateExpiration),
        source: this.stock.source,
        period_pao: this.stock.periodPao,
        date_opened: this.dateConversion(this.stock.dateOpened),
        code_storage: this.stock.codeStorage,
        date_loaned: this.dateConversion(this.stock.dateLoaned),
        borrower: this.stock.borrower,
        email_borrower: this.stock.emailBorrower,
        available_cip: this.stock.availableCIP,
        stock_id: this.stockId,
        capacity: this.stock.packageCapacityId,
        type_pack: this.stock.typePackId,
      };
      return stock;
    },
    stockCamelCase() {
      const stock = {
        datePurchase: this.myStock.date_purchase,
        dateExpiration: this.myStock.date_expiration,
        source: this.myStock.source,
        periodPao: this.myStock.period_pao,
        dateOpened: this.myStock.date_opened,
        codeStorage: this.myStock.code_storage,
        dateLoaned: this.myStock.date_loaned,
        borrower: this.myStock.borrower,
        emailBorrower: this.myStock.email_borrower,
        availableCIP: this.myStock.available_cip,
        isLoaned: !!this.myStock.date_loaned,
        isOpened: !!this.myStock.date_opened,
        objectID: this.myStock.stock_id,
        packageCapacityId: this.myStock.capacity,
        typePackId: this.myStock.type_pack,
      };
      return stock;
    },
  },
  watch: {
    'stock.isLoaned': function (value) {
      // Clear stock.dateLoaned if loan status === false
      if (!value) {
        this.stock.dateLoaned = null;
        this.stock.emailBorrower = '';
        this.stock.borrower = '';
      }
    },
    'stock.dateOpened': function (value) {
      if (value) {
        this.stock.isOpened = true;
      }
    },
    'stock.periodPao': function () {
      this.getStockStatus();
    },
  },
  methods: {
    ...mapActions([
      'toggleTableView',
      'triggerNewSearch',
      'updateStockList',
    ]),
    performAction(action) {
      this[action]();
    },
    addStockEntry() {
      // Link with product
      HTTP.post(`api/products/${this.productId}/stocks`, this.stockSnakeCase)
        .then(() => {
          // Do something on success
          // Alert on success
          this.sweetAlert('success', this.labels.product_added_to_stock, timer);
          // redirect to stock list
          eventBus.$emit('addStockEntry', this.stockSnakeCase);
          // this.$router.push('/dashboard/manage-stock')
        })
        .catch((err) => {
          console.log(err);
          this.sweetAlert('error', this.labels.error_adding_product, timer);
        });
    },
    updateStock() {
      HTTP.put(`api/products/${this.productId}/stocks/${this.stockId}`, this.stockSnakeCase)
        .then(() => {
          // Update stock list
          this.updateStockList({ stock: this.stock });
          // Alert on success
          this.sweetAlert('success', this.labels.stock_modified, timer);
          // Close the table view
          this.toggleTableView(null);
          // Refresh algolia results to show new data
          this.triggerNewSearch();
          // redirect to stock list
          eventBus.$emit('updateStock', this.stockSnakeCase, this.index);
        })
        .catch((err) => {
          console.log(err);
          this.sweetAlert('error', this.labels.error_updating_stock, timer);
        });
    },
    duplicateStock(target, source) {
      for (const prop in source) {
        target[prop] = source[prop];
      }

      this.editingStock && this.editingStock.dateLoaned ? this.stock.isLoaned = true : null;
      this.editingStock && this.editingStock.dateOpened ? this.stock.isOpened = true : null;
    },
    dateConversion(property) {
      return property ? new Date(property * 1000) : null;
    },
    timeDelay(delay) {
      const my = this;
      this.timeout = setTimeout(() => {
        my.initDatePicker(my.stock, 'stockForm');
      }, delay);
    },
    getStockStatus() {
      if (this.stock.dateExpiration && (this.stock.dateExpiration < this.today)) {
        this.stock.status = 'expired';
      } else if (this.stock.dateOpened && this.stock.periodPao && (this.dateWithMonths(this.stock.periodPao, this.stock.dateOpened) < this.today)) {
        this.stock.status = 'expired';
      } else if (this.stock.dateExpiration && (this.dateWithMonths(-1, this.stock.dateExpiration) < this.today)) {
        this.stock.status = 'expiring_soon';
      } else if (this.stock.dateOpened && this.stock.periodPao && (this.dateWithMonths(this.stock.periodPao, this.dateWithMonths(-1, this.stock.dateOpened))) < this.today) {
        this.stock.status = 'expiring_soon';
      } else {
        this.stock.status = 'ok';
      }
    },
    dateWithMonths(months, date) {
      // Deep clone the javascript date object with getTime() otherwise any date methods will effect the original date
      let newDate;
      date ? newDate = this.dateConversion(date) : newDate = new Date();
      newDate.setMonth(newDate.getMonth() + months);
      return newDate.getTime() / 1000;
    },
    cancelForm() {
      this.openedIndex !== null ? this.toggleTableView(null) : eventBus.$emit('cancelForm');
    },
    clearDate(picker) {
      const dateInput = $(`[data-name='${picker}']`);
      $(dateInput).datepicker('setDate', null);
    },
    setDefaultValues() {
      if (this.product.type_packs.length === 1) {
        this.stock.typePackId = this.product.type_packs[0];
      }

      if (this.product.package_capacities.length === 1) {
        this.stock.packageCapacityId = this.product.package_capacities[0];
      }
    },
  },
  mounted() {
    // Init choices
    const stockChoices = new Choices(`.stock-choices-${this.index}`, {
      searchChoices: true,
      searchFields: ['label'],
      shouldSort: false,
    });

    // init datepicker
    this.stockId && this.id === 'edit' ? this.timeDelay(500) : this.timeDelay(0);
  },
  created() {
    // Clone stock info if in editing mode
    if (this.myStock) {
      this.duplicateStock(this.stock, this.stockCamelCase);
    } else if (this.editingStock) {
      this.duplicateStock(this.stock, this.editingStock);
    } else {
      this.setDefaultValues();
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Stocks/StockForm.vue